import { useState } from 'react'
import SymbolIcon from './SymbolIcon'
import './PasswordInput.css'

function PasswordInput({ value, onChange, disabled = false, invalid = false, autoComplete }) {
  const [isVisible, setIsVisible] = useState(false)
  const visibilityLabel = isVisible ? 'Passwort verbergen' : 'Passwort anzeigen'

  return (
    <div className={`password-input-wrap${invalid ? ' is-invalid' : ''}`}>
      <input
        type={isVisible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        autoComplete={autoComplete}
      />
      <button
        className="password-visibility-toggle"
        type="button"
        onClick={() => setIsVisible((prev) => !prev)}
        disabled={disabled}
        aria-label={visibilityLabel}
        aria-pressed={isVisible}
        title={visibilityLabel}
      >
        <SymbolIcon icon={isVisible ? 'visibility_off' : 'visibility'} />
      </button>
    </div>
  )
}

export default PasswordInput
